// extracted by mini-css-extract-plugin
export var grid = "FoodCardSection-module--grid--3en3d";
export var odd_number = "FoodCardSection-module--odd_number--2bfvV";